import i18n from "../../translations";
import * as utils from "../../helpers/utils";

export const sendOTPRequest = (mobileNumber, service) => {
  return {
    mobile: mobileNumber,
    channel: "Portal",
    businessService: service,
    language: utils.getNumberLanguageMapper(i18n.language),
  };
};

export const sendOTPWithFlagRequest = (mobileNumber, service, id) => {
  return {
    idNumber: id,
    mobile: mobileNumber,
    channel: "Portal",
    // businessService: service,
    businessService: "StorePortal",
    language: utils.getNumberLanguageMapper(i18n.language),
    customText: "",
    module : service
  };
};

export const sendOTPResponse = (response) => {
  return response.data;
};



export const verifyOTPRequest = (mobileNumber, otp) => {
  return {
    mobile: mobileNumber,
    channel: "Portal",
    otpCode: otp,
    language: utils.getOneLetterLanguageCode(i18n.language),
  };
};

export const verifyOTPWithFlagRequest = (mobileNumber, otp, id, isInternal) => {
  return {
    isInternal: isInternal,
    idNumber: id,
    mobile: mobileNumber,
    channel: "Portal",
    otpCode: otp,
    language: utils.getOneLetterLanguageCode(i18n.language),
  };
};



export const verifyOrderRequest = (refId,systemId) => {
  return  {
    systemId: systemId || "MOTOR",
    applicationType:"RHSP",
    langCode: utils.getOneLetterLanguageCode(i18n.language),
    referenceId: refId,
    channelCode:"Portal"
  };
};


export const verifyOTPResponse = (response) => {
  return response;
};
